import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SharedModule } from 'src/app/shared/shared.module';
import { PopoverModule } from '../popover/popover.module';
import { TooltipTextComponent } from './tooltip-text.component';

@NgModule({
  imports: [CommonModule, PopoverModule, SharedModule, TooltipTextComponent],
  exports: [TooltipTextComponent],
})
export class TooltipTextModule {}
